import { CommonModule } from '@angular/common';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';

export interface ViewportGuidanceDialogData {
  width: number;
  height: number;
  isVeryCramped: boolean;
}

export type ViewportGuidanceDialogResult = 'dismiss' | 'snooze';

@Component({
  selector: 'app-viewport-guidance-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './viewport-guidance-dialog.component.html',
  styleUrls: ['./viewport-guidance-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ViewportGuidanceDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ViewportGuidanceDialogData,
    private readonly dialogRef: MatDialogRef<
      ViewportGuidanceDialogComponent,
      ViewportGuidanceDialogResult
    >
  ) {}

  close(): void {
    this.dialogRef.close('dismiss');
  }

  snoozeToday(): void {
    this.dialogRef.close('snooze');
  }
}
